import { Component,Input, OnInit } from '@angular/core';
import { TranslationService } from '../../../../../config/_core/services/translation.service';
@Component({
  selector: 'm-date-view-html',
  template: `
    <span *ngIf="type=='date' && (translationService.actualLang$ | async)=='es'">
        {{value | date: 'dd/MM/yyyy'}}
    </span>
    <span *ngIf="type=='date' && (translationService.actualLang$ | async)=='en'">
        {{value | date: 'MM/dd/yyyy'}}
    </span>
    <span *ngIf="type=='datetime' && (translationService.actualLang$ | async)=='es'">
        {{value | date: 'dd/MM/yyyy HH:mm a'}}
    </span>
    <span *ngIf="type=='datetime' && (translationService.actualLang$ | async)=='en'">
        {{value | date: 'MM/dd/yyyy HH:mm a'}}
    </span>
    <span *ngIf="type=='datetimefull' && (translationService.actualLang$ | async)=='es'">
        {{value | date: 'dd/MM/yyyy HH:mm:ss'}}
    </span>
    <span *ngIf="type=='datetimefull' && (translationService.actualLang$ | async)=='en'">
        {{value | date: 'MM/dd/yyyy HH:mm:ss'}}
    </span>
    <span *ngIf="type=='string' && (translationService.actualLang$ | async)=='es'">
        {{depurate_value()}}
    </span>
    <span *ngIf="type=='string' && (translationService.actualLang$ | async)=='en'">
        {{depurate_value()}}
    </span>
    `
})
export class DateViewHtmlComponent implements OnInit {
  @Input() value=null;
  @Input() type:string=null;
  constructor(
    private translationService: TranslationService
  ) { }
  depurate_value=()=>{
    if(!this.id_date()){
        return this.value;
    }else{
       let split = this.value.split("-");
       return this.translationService.getSelectedLanguage()=="es"? this.value: split[1]+'-'+split[0]+'-'+split[2];
    }
  }
  id_date=()=>{
    let regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    return regex.test(this.value) && this.value?true:false;
  }
  format_es=()=>{
    return this.value?this.value.replace("-","/").replace("-","/").replace("-","/"):null;
  }
  ngOnInit(): void {
  }
}